import {
  McpChangesetListResponse,
  McpChangesetResponse,
  McpConnectionInfoResponse,
} from "@/types/mcpTypes";
import { Client } from "./client";

export class McpFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readConnectionInfo(): Promise<McpConnectionInfoResponse> {
    return this.client.read('/api/mcp-console/connection');
  }

  readChangesets(scope: 'open' | 'recent'): Promise<McpChangesetListResponse> {
    return this.client.read(`/api/mcp-console/changesets?scope=${scope}`);
  }

  readChangeset(changesetId: string): Promise<McpChangesetResponse> {
    return this.client.read(`/api/mcp-console/changesets/${encodeURIComponent(changesetId)}`);
  }

  approve(changesetId: string, actionIds: string[]): Promise<McpChangesetResponse> {
    return this.client.create(`/api/mcp-console/changesets/${encodeURIComponent(changesetId)}/approve`, { actionIds });
  }

  reject(changesetId: string, actionIds: string[]): Promise<McpChangesetResponse> {
    return this.client.create(`/api/mcp-console/changesets/${encodeURIComponent(changesetId)}/reject`, { actionIds });
  }
}
